import auth from '../apis/auth.js'
import store from '../apis/store.js'
import order from '../apis/order.js'
import receiptTemplate from '../apis/receiptTemplate.js'
import payer from '../apis/payer.js'
import product from '../apis/product.js'
import paymentTool from '../apis/paymentTool'
import company from '../apis/company'
import ticket from '../apis/ticket'
import activity from '../apis/activity'

export default {
  auth,
  store,
  order,
  receiptTemplate,
  payer,
  product,
  paymentTool,
  company,
  ticket,
  activity

}
